/* eslint-disable deprecation/deprecation */
import * as React from 'react';
import { BaseFlyoutListMenuProps, GenericFlyoutListMenuProps, GenericFlyoutListMenuWidget } from './FlyoutListMenuWidget';
import { BaseListMenuProps } from './ListMenuWidget';
import { convertMenuItemInfoToGeneric, MenuItemInfo } from './MenuItemInfo';

export { GenericFlyoutListMenuProps };

export interface ListMenuProps extends Omit<BaseListMenuProps, '__INTERNAL__focusIndex'> {
  /** The contents of the menu as an array of MenuItemInfos */
  menuItemInfos: MenuItemInfo[];
}

export interface FlyoutListMenuProps extends ListMenuProps, BaseFlyoutListMenuProps { }

export const FlyoutListMenuWidget: React.FC<FlyoutListMenuProps> = props => {
  const convertedProps = { ...props, menuItemInfos: convertMenuItemInfoToGeneric(props.menuItemInfos) };

  return React.createElement(GenericFlyoutListMenuWidget, convertedProps);
};
FlyoutListMenuWidget.displayName = 'FlyoutListMenuWidget';
